export enum GlobalMessageActionTypes {
  SHOW_GLOBAL_MESSAGE = 'SHOW_GLOBAL_MESSAGE',
  HIDE_GLOBAL_MESSAGE = 'HIDE_GLOBAL_MESSAGE',
}

export type ShowGlobalMessageAction = {
  type: GlobalMessageActionTypes.SHOW_GLOBAL_MESSAGE,
  payload: GlobalMessage
};

export type HideGlobalMessageAction = {
  type: GlobalMessageActionTypes.HIDE_GLOBAL_MESSAGE,
};

export type GlobalMessageAction = ShowGlobalMessageAction | HideGlobalMessageAction;
